import React from "react"

import {FieldEditableMode, FieldEditableProps, FieldEditableState} from "../../../../proto/render/editable"
import {FieldViewSize} from "../../../../const"
import FieldView from "../../../../render/view"

const debug = false
// const debug = "FieldProjectColorIcon_Editable"

export default class FieldProjectColorIcon_Editable extends React.Component<FieldEditableProps, FieldEditableState> {

    constructor(props:FieldEditableProps) {
        super(props)

        debug && console.log(debug, 'constructor', this.props)

        this.state = {
            mode: FieldEditableMode.VIEW
        }
    }

    get canEdit():boolean {
        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) {
            return false
        }
        return true
    }

    get classes():string {
        return Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) {
            this.setState({
                mode: FieldEditableMode.HOVERED
            })
        }
    }

    onMouseLeave = () => {
        if (this.state.mode === FieldEditableMode.HOVERED) {
            this.setState({
                mode: FieldEditableMode.VIEW
            })
        }
    }

    onOptionClick = (option: Option)=>{
        this.onValueChange(option.value as number)
    }

    onValueChange = async (value: number|null, hidePopover:boolean=true) => {
        // make it first (!) to update model and hidePopover will reRerender(!)
        this.props.onChange && this.props.onChange(value)

        hidePopover && this.hidePopover()
    }

    onClick = () => {
        if (!this.canEdit) return

        this.setState({
            mode: FieldEditableMode.EDITING
        })
    }

    hidePopover = () => {
        this.setState({
            mode: FieldEditableMode.VIEW
        })
    }

    render() {
        debug && console.log(debug, "render", this.state.mode, this.props)

        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
            "is-hovered"                    : [FieldEditableMode.EDITING, FieldEditableMode.HOVERED].includes(this.state.mode)
        })

        const showPopover = this.state.mode === FieldEditableMode.EDITING

        return (
            <div className      = {classes}
                 style          = {this.props.style}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}
                 onClick        = {this.onClick}>
                <FieldView className    = "m-r-15"
                           field        = {gd.fields.project.projectIcon}
                           model        = {this.props.model}/>

                <FieldView field        = {gd.fields.project.color}
                           model        = {this.props.model}/>

                {showPopover &&
                    <this.props.field.components.PopoverMenu parent    = {this}
                                                             field     = {this.props.field}
                                                             model     = {this.props.model}/>}
            </div>
        )
    }
}



